import moment from 'moment';
import React, { FC } from 'react';
import { Link } from 'react-router-dom';
import { FaPlay } from 'react-icons/fa';
import { UserDetail } from '../../types/api/users/UserDetail';
import { Button, Card, Table } from 'react-bootstrap';
import { PersonPackageSummary } from '../../types/api/enrollmentPackages/PersonPackageSummary';

interface Props {
  currentUser: UserDetail;
  enrollmentList: PersonPackageSummary[];
}

export const EnrollmentPackageList: FC<Props> = ({currentUser, enrollmentList}) => {

	const renderEnrollments = () => {
		return enrollmentList.map((enrollment, key) => {
			return (
				<tr key={key}>
					<td>
						{enrollment.groupName}
					</td>
					<td>
						{enrollment.packageType}
					</td>
					<td>
						{moment(enrollment.startDate).format('MM/D/YYYY')}
					</td>
					<td>
						{moment(enrollment.endDate).format('MM/D/YYYY')}
					</td>
					<td>
						{enrollment.status}
					</td>
					<td>
						{enrollment.isEditable && currentUser &&
							<Link to={`packages/${enrollment.enrollmentPackageId}/welcome`}>
								<Button size="sm"><FaPlay /> Enroll</Button>
							</Link>
						}
						{!enrollment.isEditable && currentUser &&
							<Link to={`approved-summary/${enrollment.enrollmentPackageId}`}>
								<Button size="sm"><FaPlay /> Summary</Button>
							</Link>
						}
					</td>
				</tr>
			);
		});
	};

	return (
		<Card>
			<Card.Body>
				<h2>Packages</h2>
				<Table responsive>
					<thead>
						<tr>
							<th>Group Name</th>
							<th>Package Type</th>
							<th>Enrollment Start Date</th>
							<th>Enrollment Deadline</th>
							<th>Progress</th>
							<th />
						</tr>
					</thead>
					<tbody>
						{renderEnrollments()}
					</tbody>
				</Table>
			</Card.Body>
		</Card>
	);
};